export const pricing = {
  "breadcrumb": "Τιμές",
  "title": "Απλές και ευέλικτες τιμές",
  "subtitle": "Μία ενιαία προμήθεια 5%, που πληρώνεται από όποιον θέλετε.",
  "whoPays": {
    "title": "Ποιος πληρώνει τα έξοδα;",
    "traveler": {
      "label": "Επιλογή 1: Πληρώνει ο ταξιδιώτης (Συνιστάται)",
      "description": "Λαμβάνετε το 100% της τιμής σας. Ο ταξιδιώτης προσθέτει 5% έξοδα υπηρεσίας.",
      "badge": "Προεπιλογή"
    },
    "host": {
      "label": "Επιλογή 2: Πληρώνει ο οικοδεσπότης (Pro)",
      "description": "Πληρώνετε εσείς το 5%. Η τιμή που εμφανίζεται είναι χαμηλότερη για τον ταξιδιώτη, ιδανικό για εταιρείες.",
      "badge": "Επιλογή Pro"
    }
  },
  "guarantee": "Εγγύηση πλήρους διαφάνειας",
  "perYear": "/έτος",
  "choose": "Επιλογή",
  "popular": "Το πιο δημοφιλές",
  "plans": {
    "traveler": {
      "name": "Ταξιδιώτης",
      "description": "Για να εξερευνήσετε τον κόσμο με χαμηλό κόστος",
      "price": "5%",
      "period": "προμήθεια",
      "features": [
        "Πρόσβαση σε όλα τα καταλύματα",
        "Μειωμένα έξοδα υπηρεσίας (5%)",
        "Περιλαμβάνεται ασφάλεια",
        "Υποστήριξη 7/7",
        "Χωρίς κρυφές χρεώσεις"
      ]
    },
    "host": {
      "name": "Οικοδεσπότης",
      "description": "Για ενοικίαση χωρίς έξοδα και ανταλλαγή",
      "price": "0%",
      "period": "προμήθεια",
      "features": [
        "0% προμήθεια στα έσοδά σας",
        "Πρόσβαση σε δωρεάν ανταλλαγές μεταξύ οικοδεσποτών",
        "Διαθέσιμο σήμα \"Δίκαιη Τιμή\"",
        "Αυξημένη ορατότητα",
        "Προτεραιότητα υποστήριξης"
      ]
    }
  },
  "fairPrice": {
    "title": "Πρόγραμμα Δίκαιη Τιμή",
    "description": "Παίξτε το παιχνίδι, κερδίστε περισσότερα.",
    "benefit1": "Σήμα \"Δίκαιη Τιμή\" ορατό",
    "benefit2": "Προτεραιότητα στα αποτελέσματα",
    "benefit3": "Μπόνους πόντων ανταλλαγής",
    "condition": "Προτείνετε μια τιμή τουλάχιστον 10% φθηνότερη από άλλες πλατφόρμες."
  },
  "taxAdvantage": {
    "title": "Φορολογικό Πλεονέκτημα & Pro",
    "text": "Τα έξοδα 5% μπορούν να αφαιρεθούν από τα έξοδά σας αν είστε εταιρεία. Το μοντέλο 0% απλοποιεί τη λογιστική για ιδιώτες. Συμβουλευτείτε τον λογιστή σας."
  },
  "hostExchange": {
    "title": "Σύστημα Ανταλλαγής Οικοδεσπότη",
    "description": "Ανταλλάξτε τις κερδισμένες νύχτες σας με δωρεάν διαμονές.",
    "free": "Δωρεάν (0€)",
    "community": "Αποκλειστικά για επαληθευμένα μέλη"
  },
  "comparison": {
    "title": "Γιατί είναι καλύτερο;",
    "subtitle": "Συγκρίνετε και δείτε τη διαφορά",
    "features": "Χρεώσεις",
    "airbnb": "Airbnb / Booking",
    "traveltrok": "DONKEY TRAVEL",
    "hostFees": "Χρεώσεις Οικοδεσπότη",
    "travelerFees": "Χρεώσεις Ταξιδιώτη",
    "exchange": "Δωρεάν Ανταλλαγή"
  },
  "testimonials": {
    "title": "Τι λένε τα μέλη μας",
    "subtitle": "Γίνετε μέλος μιας κοινότητας που αλλάζει τους κανόνες",
    "badge": "Μαρτυρίες",
    "exchanges": "ανταλλαγές",
    "saved": "εξοικονόμηση",
    "verifiedMembers": "+15.000 μέλη",
    "completedExchanges": "+50.000 ταξίδια",
    "totalSaved": "0% προμήθεια"
  },
  "faq": {
    "title": "Συχνές ερωτήσεις",
    "subtitle": "Όλα όσα πρέπει να γνωρίζετε για τις τιμές μας",
    "q1": {
      "question": "Μπορώ να αλλάξω πλάνο ανά πάσα στιγμή;",
      "answer": "Ναι, μπορείτε να αναβαθμίσετε σε ανώτερο πλάνο ανά πάσα στιγμή. Η διαφορά θα υπολογιστεί αναλογικά με την τρέχουσα συνδρομή σας."
    },
    "q2": {
      "question": "Υπάρχουν επιπλέον χρεώσεις;",
      "answer": "Όχι, καμία κρυφή χρέωση. Η τιμή που εμφανίζεται είναι η τελική τιμή που πληρώνετε ετησίως. Οι ανταλλαγές είναι στη συνέχεια εντελώς δωρεάν."
    },
    "q3": {
      "question": "Τι συμβαίνει αν δεν είμαι ικανοποιημένος;",
      "answer": "Προσφέρουμε εγγύηση επιστροφής χρημάτων 30 ημερών. Αν δεν είστε ικανοποιημένοι, σας επιστρέφουμε τα χρήματα στο ακέραιο."
    },
    "q4": {
      "question": "Πώς λειτουργεί η χρέωση;",
      "answer": "Χρεώνεστε ετησίως. Μπορείτε να πληρώσετε με πιστωτική κάρτα ή έμβασμα. Η χρέωση είναι αυτόματη και λαμβάνετε τιμολόγιο μέσω email."
    },
    "q5": {
      "question": "Μπορώ να ακυρώσω τη συνδρομή μου;",
      "answer": "Ναι, μπορείτε να ακυρώσετε ανά πάσα στιγμή. Η συνδρομή σας θα παραμείνει ενεργή μέχρι το τέλος της πληρωμένης περιόδου."
    }
  },
  "cta": {
    "title": "Έτοιμοι να ξεκινήσετε την περιπέτεια;",
    "subtitle": "Γίνετε μέλος χιλιάδων ιδιοκτητών που ταξιδεύουν δωρεάν",
    "createAccount": "Δημιουργία λογαριασμού",
    "exploreDestinations": "Εξερεύνηση προορισμών"
  },
  "signup": {
    "title": "Δημιουργία λογαριασμού",
    "subtitle": "Γίνετε μέλος της κοινότητας ιδιοκτητών μας",
    "firstName": "Όνομα",
    "lastName": "Επώνυμο",
    "email": "Email",
    "phone": "Τηλέφωνο",
    "country": "Χώρα",
    "selectCountry": "Επιλέξτε τη χώρα σας",
    "plan": "Πλάνο",
    "selectPlan": "Επιλέξτε το πλάνο σας",
    "propertyType": "Τύπος καταλύματος",
    "selectPropertyType": "Επιλέξτε τον τύπο καταλύματος",
    "terms": "Αποδέχομαι τους όρους χρήσης και την πολιτική απορρήτου",
    "submit": "Δημιουργία λογαριασμού",
    "success": "Ο λογαριασμός δημιουργήθηκε με επιτυχία!",
    "error": "Παρουσιάστηκε σφάλμα. Παρακαλώ δοκιμάστε ξανά.",
    "securityNote": "Τα δεδομένα σας είναι ασφαλή και δεν θα κοινοποιηθούν ποτέ",
    "house": "Σπίτι",
    "apartment": "Διαμέρισμα",
    "villa": "Βίλα",
    "loft": "Λοφτ",
    "other": "Άλλο"
  },
  "signupSection": {
    "title": "Γίνετε μέλος του DONKEY TRAVEL σήμερα",
    "subtitle": "Δημιουργήστε τον λογαριασμό σας σε λίγα λεπτά και αρχίστε να ανταλλάσσετε το σπίτι σας με ιδιοκτήτες από όλο τον κόσμο.",
    "verifiedMembers": "Επαληθευμένα μέλη",
    "verifiedMembersDesc": "Όλα τα μέλη μας είναι επαληθευμένοι ιδιοκτήτες Airbnb για ανταλλαγές με εμπιστοσύνη.",
    "guaranteedSavings": "Εγγυημένη εξοικονόμηση",
    "guaranteedSavingsDesc": "Τα μέλη μας εξοικονομούν κατά μέσο όρο 3.500€ ετησίως στα έξοδα διαμονής τους.",
    "globalNetwork": "Παγκόσμιο δίκτυο",
    "globalNetworkDesc": "Πρόσβαση σε περισσότερα από 15.000 καταλύματα σε 85 χώρες σε όλο τον κόσμο.",
    "responsiveSupport": "Άμεση υποστήριξη",
    "responsiveSupportDesc": "Η ομάδα μας είναι διαθέσιμη 7/7 για να σας συνοδεύσει στις ανταλλαγές σας."
  },
  "testimonialItems": {
    "sophie": "Χάρη στο DONKEY TRAVEL, επισκέφτηκα τη Βαρκελώνη, τη Ρώμη και το Άμστερνταμ χωρίς να πληρώσω διαμονή. Η κοινότητα είναι ενεργή και οι συζητήσεις ανταλλαγής απλές.",
    "thomas": "Μπήκα στην προσφορά γνωριμίας 2026: -50% τον πρώτο χρόνο. Η τιμή είναι εγγυημένη εφ' όρου ζωής για τους πρώτους 1000, και ανταλλάσσω παντού στην Ευρώπη.",
    "marie": "Έκανα επιτέλους την πρώτη μου ανταλλαγή στην Ευρώπη, και όλα κύλησαν ομαλά από το πρώτο μήνυμα μέχρι την άφιξη. Η επαλήθευση των προφίλ βοηθάει πραγματικά.",
    "pierre": "Για τα καταλύματά μας, ο πίνακας ελέγχου μας εξοικονομεί χρόνο: αγγελίες, μηνύματα και διαθεσιμότητες είναι ξεκάθαρα και εύκολα στη διαχείριση."
  }
};
